import React from "react";
import { Form, Row, Col, Typography, Button, Icon } from "antd";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import './signin.less'
import Error401 from "../routes/errorPages/401";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;
const { Text, Title } = Typography;
const Orion = ['internal_agent', 'partner', 'qa', 'agent', 'admin', 'partner_employee']
const FC = ['finance_user', 'accounts_user', 'payable_partner_user','client_invoicer']
const PMT = ['project_manager', 'verify_scheduler', 'coordinator', 'client_user', 'client_manager', 'admin', 'client_admin', 'auditor_user','qc', 'kci']

class Interstitial extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: localStorage.getItem('all_roles').split(","),
      finance: null,
      PMT: null,
      orion: null,
      visibleRole: true,
      logedInUs:null,
    }
    // console.log('props',props.logedInUser)

  }


  capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  componentDidMount = () => {
  
    this.setState({logedInUs:localStorage.getItem('loged_in_to')})

    for (let i = 0; i < this.state.role.length; i++) {
      if (FC.indexOf(this.state.role[i]) >= 0) {
        console.log(this.state.role[i],'fc')
        this.setState({ finance: this.state.role[i] })
      }
      if (Orion.indexOf(this.state.role[i]) >= 0) {
        console.log(this.state.role[i],'orion')
        this.setState({ orion: this.state.role[i] })
      }
      if (PMT.indexOf(this.state.role[i]) >= 0) {
        console.log(this.state.role[i],'pmt')
        // this.state.role[i] === "client_user" || this.state.role[i] === 'client_manager' || this.state.role[i] === "client_admin" || this.state.role[i] === "auditor_user" || this.state.role[i] === 'verify_scheduler' ||
        //   this.state.role[i] === "project_manager" || this.state.role[i] === "admin" || this.state.role[i] === "coordinator" ?
          // this.setState({ PMT: this.props.logedInUser.user_role }) : 
          this.setState({ PMT: this.state.role[i] })
      }
    }
  }

  onClick = (role, type) => {
    // console.log(role,'role.........................!')
    localStorage.setItem('user_role', role)
    localStorage.setItem('loged_in_to', type)
    this.setState({logedInUs:type})
  }
  showRoles = () => {
    this.setState({ visibleRole: !this.state.visibleRole })
    this.setState({logedInUs:'pmt'})
  }

  getPortalTitle = () => {
    if (this.state.logedInUs === 'pmt') {
      return 'Project Management';
    } else if (this.state.logedInUs === 'orion') {
      return 'Partner Management';
    } else if (this.state.logedInUs === 'fc') {
      return 'Finance Central';
    }
    return 'Matrix';
  }

  getPortalSubtitle = () => {
    if (this.state.logedInUs === 'pmt') {
      return 'Select your role to continue';
    } else if (this.state.logedInUs === 'orion') {
      return 'Select your role to continue';
    } else if (this.state.logedInUs === 'fc') {
      return 'Select your role to continue';
    }
    return 'Choose your portal to get started';
  }

  render() {
    const users = this.state.role.filter((element) => {
      if(this.state.logedInUs === 'pmt'){
        return PMT.includes(element)
      }else if(this.state.logedInUs === 'orion'){
        return Orion.includes(element)
      }else if (this.state.logedInUs === 'fc'){
        return FC.includes(element)
      }else{
        return []
      }
    });

    const portalOptions = [];
    if (this.state.orion) {
      portalOptions.push({
        label: 'Go to Partner Management',
        icon: 'team',
        color: '#630086',
        onClick: () => this.onClick(this.state.orion, "orion"),
        link: {pathname: "/signin", state: {from: { pathname: this.props?.location?.state?.from?.pathname } }},
        type: 'orion'
      });
    }
    if (this.state.finance) {
      portalOptions.push({
        label: 'Go to Finance Central',
        icon: 'wallet',
        color: '#630086',
        onClick: () => this.onClick(this.state.finance, "fc"),
        link: {pathname: "/signin", state: {from: { pathname: this.props?.location?.state?.from?.pathname } }},
        type: 'fc'
      });
    }
    if (this.state.PMT) {
      portalOptions.push({
        label: 'Go to Project Management',
        icon: 'appstore',
        color: '#630086',
        onClick: this.showRoles,
        link: null,
        type: 'pmt'
      });
    }

    return (
      <div className="gx-app-login-wrap modern-signin-wrapper">
        <div className="gx-app-login-container modern-signin-container">
          <Row type="flex" align="middle" className="gx-app-login-main-content modern-signin-main" gutter={0}>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-left">
              <div 
                className="modern-signin-left-bg"
                style={{backgroundColor: '#FAFAFA'}}
              >
                <div className="modern-signin-left-content">
                  <div className="modern-signin-logo -mobile-logo">
                    <img src={require('assets/images/LogoUniserved.png')} alt='Logo' />
                  </div>
                  <h1 className="modern-signin-title">{this.getPortalTitle()}</h1>
                  <p className="modern-signin-subtitle">{this.getPortalSubtitle()}</p>
                  <img src={require('assets/images/Service_Technicians_at_Work.png')} alt='Graphic' className="modern-signin-graphic" />
                </div>
              </div>
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-right">
              <div className="modern-signin-form-container">
                <div className="modern-signin-header">
                  <div className="modern-signin-header-left">
                    <Title level={2} className="modern-signin-header-title">Matrix</Title>
                    <Text className="modern-signin-header-subtitle">Field Services Management</Text>
                  </div>
                  <div className="modern-signin-header-right">
                    <img src={require('assets/images/LogoUniserved.png')} alt='Logo' className="modern-signin-header-logo" />
                  </div>
                </div>
                <div className="modern-signin-form-content">
                  <Title level={1} className="modern-signin-form-title" style={{color: '#262626'}}>
                    {this.state.logedInUs === null ? 'Select Portal' : 'Select Role'}
                  </Title>
                  <Text className="modern-signin-form-text">
                    {this.state.logedInUs === null 
                      ? 'Choose the portal you want to access. Each portal provides different features and capabilities.'
                      : 'Select the role you want to log in with. Your role determines the features and permissions available to you.'}
                  </Text>
                  
                  <div className="modern-interstitial-options">
                    {this.state.logedInUs === null ? (
                      portalOptions.map((option, index) => {
                        const content = (
                          <div className="modern-interstitial-item">
                            <div className="modern-interstitial-item-icon" style={{ backgroundColor: `${option.color}15` }}>
                              <Icon type={option.icon} style={{ color: option.color, fontSize: 24 }} />
                            </div>
                            <span className="modern-interstitial-item-label">{option.label}</span>
                            <Icon type="right" className="modern-interstitial-item-arrow" />
                          </div>
                        );

                        if (option.link) {
                          return (
                            <Link
                              key={index}
                              to={option.link}
                              onClick={option.onClick}
                              className="modern-interstitial-link"
                              style={{ borderLeftColor: option.color }}
                            >
                              {content}
                            </Link>
                          );
                        }

                        return (
                          <a
                            key={index}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              option.onClick();
                            }}
                            className="modern-interstitial-link"
                            style={{ borderLeftColor: option.color }}
                          >
                            {content}
                          </a>
                        );
                      })
                    ) : (
                      users.length !== 0 ? (
                        users.map((role, index) => (
                          <Link
                            key={index}
                            to={{pathname: "/signin", state: {from: { pathname: this.props?.location?.state?.from?.pathname } }}}
                            onClick={() => this.onClick(role, this.state.logedInUs)}
                            className="modern-interstitial-link"
                            style={{ borderLeftColor: '#630086' }}
                          >
                            <div className="modern-interstitial-item">
                              <div className="modern-interstitial-item-icon" style={{ backgroundColor: '#63008615' }}>
                                <Icon type="user" style={{ color: '#630086', fontSize: 24 }} />
                              </div>
                              <span className="modern-interstitial-item-label">
                                Log In as {this.capitalizeFirstLetter(role).replace(/_/g, " ")}
                              </span>
                              <Icon type="right" className="modern-interstitial-item-arrow" />
                            </div>
                          </Link>
                        ))
                      ) : (
                        <Error401/>
                      )
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(Interstitial);

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, logedInUser } = auth;
  return { loader, alertMessage, showMessage, authUser, logedInUser }
};

export default connect(mapStateToProps,)(WrappedNormalLoginForm);
